import React from "react";
import downloadIcon from "../../Assets/svg/download-icon.svg";

/**
 * "Report" download button for master listing pages, styled to match the
 * adjacent Upload / Template buttons. Place it near the Upload button.
 *
 * @param {object} props
 * @param {() => void} props.onClick   triggers the report download
 * @param {boolean} [props.loading]    shows a spinner and disables the click
 * @param {string} [props.label]       button text (default "Report")
 */
const ReportButton = ({ onClick, loading = false, label = "Download" }) => {
  return (
    <div
      data-testid="report-button"
      onClick={() => !loading && onClick()}
      style={{
        height: "40px",
        borderRadius: "100px",
        padding: "8px 16px",
        gap: "8px",
        backgroundColor: "#5DCB8C",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: loading ? "not-allowed" : "pointer",
      }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <img
          src={downloadIcon}
          alt="report"
          style={{
            width: "16px",
            height: "16px",
            // Recolor the SVG icon to white to match the button text.
            filter: "brightness(0) invert(1)",
          }}
        />
      )}
      <p
        style={{
          margin: "0",
          fontFamily: "Satoshi",
          fontWeight: "700",
          fontSize: "14px",
          lineHeight: "18.9px",
          color: "#FFFFFF",
        }}
      >
        {label}
      </p>
    </div>
  );
};

export default ReportButton;
